import { render } from "react-dom";
import App from "./App";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "UA-16962571-1",
};
TagManager.initialize(tagManagerArgs);

render(<App />, document.getElementById("root"));
